import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { QUERY_KEYS } from 'src/constants'
import { paymentsService } from 'src/services/payments.service'

export const useAccountSubscriptionPrices = () => {
  const { accountId } = useParams()

  return useQuery(
    [QUERY_KEYS.ACCOUNT_SUBSCRIPTION_PRICES],
    () =>
      accountId ? paymentsService.retrieveSubscriptionPrices(accountId) : Promise.resolve(null),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  )
}
